export default "/_next/static/chunks/fonts/Source Sans Pro Extra Light-eb2a2dab0d2bc9e93317da3728b83158.otf";